import React from 'react';

export default function Activities() {
  return <div className='Activities'>Activities</div>;
}
